
import React from 'react'
import Spinner from './Spinner'
import { HBox } from './Box'

/**
 * Loader indicator.
 */

export default function Loader({ delay = 300 }) {
  return <HBox align="center" flex>
    <HBox animate="show" animationDelay={delay}>
      <Spinner />
    </HBox>
  </HBox>
}